module.exports = __webpack_public_path__ + "static/Logo-44d0cef5cdeff47b0f480660c4e2ba11.png";